"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardAction = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const CardActionArea_1 = __importDefault(require("@material-ui/core/CardActionArea"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const card_styles_1 = require("../card-styles");
const dashboard_context_1 = require("../../dashboard-context");
function CardAction({ navigate, title, value }) {
    const classes = card_styles_1.useStyles();
    const { classes: classesOverride } = react_1.useContext(dashboard_context_1.DashboardContext);
    return (react_1.default.createElement(CardActionArea_1.default, { onClick: navigate },
        react_1.default.createElement(Typography_1.default, { variant: "body2", className: clsx_1.default(classes.cardAction, classesOverride === null || classesOverride === void 0 ? void 0 : classesOverride.cardAction) },
            title,
            value !== undefined && (react_1.default.createElement("span", { className: clsx_1.default(classes.cardActionValue, classesOverride === null || classesOverride === void 0 ? void 0 : classesOverride.cardActionValue) }, value)))));
}
exports.CardAction = CardAction;
//# sourceMappingURL=card-action.js.map